var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 753,
    viewBox: "0 0 305 753",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.8 152.1V306.6H0.699951V152.1H154.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 278C23.3 281.3 26 284 29.3 284C32.6 284 35.3 281.3 35.3 278C35.3 274.7 32.6 272 29.3 272C26 272 23.3 274.7 23.3 278Z",
    fill: "#FBC029"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 253.7C23.3 257 26 259.7 29.3 259.7C32.6 259.7 35.3 257 35.3 253.7C35.3 250.4 32.6 247.7 29.3 247.7C26 247.7 23.3 250.4 23.3 253.7Z",
    fill: "#FBC029"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 229.4C23.3 232.7 26 235.4 29.3 235.4C32.6 235.4 35.3 232.7 35.3 229.4C35.3 226.1 32.6 223.4 29.3 223.4C26 223.4 23.3 226.1 23.3 229.4Z",
    fill: "#FBC029"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 205.1C23.3 208.4 26 211.1 29.3 211.1C32.6 211.1 35.3 208.4 35.3 205.1C35.3 201.7 32.6 199.1 29.3 199.1C26 199.1 23.3 201.7 23.3 205.1Z",
    fill: "#FBC029"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 180.8C35.3 177.4 32.6 174.7 29.3 174.7C26 174.7 23.3 177.4 23.3 180.8C23.3 184.1 26 186.8 29.3 186.8C32.6 186.8 35.3 184.1 35.3 180.8Z",
    fill: "#FBC029"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 278C47.5 281.3 50.2 284 53.5 284C56.9 284 59.5 281.3 59.5 278C59.5 274.7 56.9 272 53.5 272C50.2 272 47.5 274.7 47.5 278Z",
    fill: "#FBC029"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 253.7C47.5 257 50.2 259.7 53.5 259.7C56.9 259.7 59.5 257 59.5 253.7C59.5 250.4 56.9 247.7 53.5 247.7C50.2 247.7 47.5 250.4 47.5 253.7Z",
    fill: "#FBC029"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 229.4C47.5 232.7 50.2 235.4 53.5 235.4C56.9 235.4 59.5 232.7 59.5 229.4C59.5 226.1 56.9 223.4 53.5 223.4C50.2 223.4 47.5 226.1 47.5 229.4Z",
    fill: "#FBC029"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 205.1C47.5 208.4 50.2 211.1 53.5 211.1C56.9 211.1 59.5 208.4 59.5 205.1C59.5 201.7 56.9 199.1 53.5 199.1C50.2 199.1 47.5 201.7 47.5 205.1Z",
    fill: "#FBC029"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 180.8C47.5 184.1 50.2 186.8 53.5 186.8C56.9 186.8 59.5 184.1 59.5 180.8C59.5 177.4 56.9 174.7 53.5 174.7C50.2 174.7 47.5 177.4 47.5 180.8Z",
    fill: "#FBC029"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 278C71.8 281.3 74.5 284 77.8 284C81.1 284 83.8 281.3 83.8 278C83.8 274.7 81.1 272 77.8 272C74.5 272 71.8 274.7 71.8 278Z",
    fill: "#FBC029"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 253.7C71.8 257 74.5 259.7 77.8 259.7C81.1 259.7 83.8 257 83.8 253.7C83.8 250.4 81.1 247.7 77.8 247.7C74.5 247.7 71.8 250.4 71.8 253.7Z",
    fill: "#FBC029"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 229.4C71.8 232.7 74.5 235.4 77.8 235.4C81.1 235.4 83.8 232.7 83.8 229.4C83.8 226.1 81.1 223.4 77.8 223.4C74.5 223.4 71.8 226.1 71.8 229.4Z",
    fill: "#FBC029"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 205.1C71.8 208.4 74.5 211.1 77.8 211.1C81.1 211.1 83.8 208.4 83.8 205.1C83.8 201.7 81.1 199.1 77.8 199.1C74.5 199.1 71.8 201.7 71.8 205.1Z",
    fill: "#FBC029"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 180.8C71.8 184.1 74.5 186.8 77.8 186.8C81.1 186.8 83.8 184.1 83.8 180.8C83.8 177.4 81.1 174.7 77.8 174.7C74.5 174.7 71.8 177.4 71.8 180.8Z",
    fill: "#FBC029"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96 278C96 281.3 98.7 284 102 284C105.3 284 108 281.3 108 278C108 274.7 105.3 272 102 272C98.7 272 96 274.7 96 278Z",
    fill: "#FBC029"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96 253.7C96 257 98.7 259.7 102 259.7C105.3 259.7 108 257 108 253.7C108 250.4 105.3 247.7 102 247.7C98.7 247.7 96 250.4 96 253.7Z",
    fill: "#FBC029"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96 229.4C96 232.7 98.7 235.4 102 235.4C105.3 235.4 108 232.7 108 229.4C108 226.1 105.3 223.4 102 223.4C98.7 223.4 96 226.1 96 229.4Z",
    fill: "#FBC029"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96 205.1C96 208.4 98.7 211.1 102 211.1C105.3 211.1 108 208.4 108 205.1C108 201.7 105.3 199.1 102 199.1C98.7 199.1 96 201.7 96 205.1Z",
    fill: "#FBC029"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96 180.8C96 184.1 98.7 186.8 102 186.8C105.3 186.8 108 184.1 108 180.8C108 177.4 105.3 174.7 102 174.7C98.7 174.7 96 177.4 96 180.8Z",
    fill: "#FBC029"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 278C120.3 281.3 122.9 284 126.2 284C129.6 284 132.3 281.3 132.3 278C132.3 274.7 129.6 272 126.2 272C122.9 272 120.3 274.7 120.3 278Z",
    fill: "#FBC029"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 253.7C120.3 257 122.9 259.7 126.2 259.7C129.6 259.7 132.3 257 132.3 253.7C132.3 250.4 129.6 247.7 126.2 247.7C122.9 247.7 120.3 250.4 120.3 253.7Z",
    fill: "#FBC029"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 229.4C120.3 232.7 122.9 235.4 126.2 235.4C129.6 235.4 132.3 232.7 132.3 229.4C132.3 226.1 129.6 223.4 126.2 223.4C122.9 223.4 120.3 226.1 120.3 229.4Z",
    fill: "#FBC029"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 205.1C120.3 208.4 122.9 211.1 126.2 211.1C129.6 211.1 132.3 208.4 132.3 205.1C132.3 201.7 129.6 199.1 126.2 199.1C122.9 199.1 120.3 201.7 120.3 205.1Z",
    fill: "#FBC029"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 180.8C120.3 184.1 122.9 186.8 126.2 186.8C129.6 186.8 132.3 184.1 132.3 180.8C132.3 177.4 129.6 174.7 126.2 174.7C122.9 174.7 120.3 177.4 120.3 180.8Z",
    fill: "#FBC029"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.9 114.2L155.1 76.2998L192.9 38.3999L155.1 0.5H192.9L230.7 38.3999L192.9 76.2998L230.7 114.2L192.9 152.1H155.1L192.9 114.2Z",
    fill: "#064DA1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M230.7 76.2998L268.5 38.3999L230.7 0.5H268.5L306.3 38.3999L268.5 76.2998L306.3 114.2L268.5 152.1H230.7L268.5 114.2L230.7 76.2998Z",
    fill: "#77B95A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.9 265.9L155.1 228L192.9 190.1L155.1 152.1H192.9L230.7 190.1L192.9 228L230.7 265.9L192.9 303.8H155.1L192.9 265.9Z",
    fill: "#FBC029"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M230.7 228L268.5 190.1L230.7 152.1H268.5L306.3 190.1L268.5 228L306.3 265.9L268.5 303.8H230.7L268.5 265.9L230.7 228Z",
    fill: "#6263A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155.1 433.5V455.1H306.7V433.5H155.1Z",
    fill: "#77C9F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.1 390.3V411.9H306.7V390.3H155.1Z",
    fill: "#77C9F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.1 303.8V325.4H306.7V303.8H155.1Z",
    fill: "#77C9F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.1 347V368.6H306.7V347H155.1Z",
    fill: "#77C9F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155.1 757.6C155.1 674 223 606.3 306.7 606.3V757.6H155.1Z",
    fill: "#EB6445"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M155.1 455.1C155.1 538.6 223 606.3 306.7 606.3V455.1H155.1Z",
    fill: "#77B95A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M153.7 0.5H1.8999V151.8H153.7V0.5Z",
    fill: "#DCE4EF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7999 42.7002C59.8999 44.0002 45.5998 58.3002 44.1998 76.2002H43.9999C42.5999 58.3002 28.3999 44.0002 10.3999 42.7002V42.5C28.3999 41.2 42.5999 26.9 43.9999 9H44.1998C45.5998 26.9 59.8999 41.2 77.7999 42.5V42.7002Z",
    fill: "#064DA1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M145.1 42.7002C127.2 44.0002 112.9 58.3002 111.5 76.2002H111.3C110 58.3002 95.7 44.0002 77.8 42.7002V42.5C95.7 41.2 110 26.9 111.3 9H111.5C112.9 26.9 127.2 41.2 145.1 42.5V42.7002Z",
    fill: "#064DA1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7999 109.8C59.8999 111.1 45.5998 125.4 44.1998 143.3H43.9999C42.5999 125.4 28.3999 111.1 10.3999 109.8V109.7C28.3999 108.4 42.5999 94.1002 43.9999 76.2002H44.1998C45.5998 94.1002 59.8999 108.4 77.7999 109.7V109.8Z",
    fill: "#064DA1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M145.1 109.8C127.2 111.1 112.9 125.4 111.5 143.3H111.3C110 125.4 95.7 111.1 77.8 109.8V109.7C95.7 108.4 110 94.1002 111.3 76.2002H111.5C112.9 94.1002 127.2 108.4 145.1 109.7V109.8Z",
    fill: "#064DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterRight);
export default __webpack_public_path__ + "static/media/footer-right.20e1f5a2492b631770d78830265eae84.svg";
export { ForwardRef as ReactComponent };